import { MenuItems } from '../types/MenuItems';

export const isSixInHash = () => {
  const { hash } = window.location;

  return (
    hash.includes(MenuItems.DASHBOARD) ||
    hash.includes(MenuItems.SHOP) ||
    hash.includes(MenuItems.SETTINGS) ||
    hash.includes(MenuItems.MARKETING) ||
    hash.includes(MenuItems.STATISTICS) ||
    hash.includes(MenuItems.FINANCE)
  );
};
